<div
  *ngIf="comoUser"
  class="flex flex-col border-solid border-4 rounded-lg m-5 p-5"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.color]="textColor | contentBuilderColor"
  [style.borderColor]="secondaryButtonBackgroundColor | contentBuilderColor"
>
  <div class="mb-5">
    <div
      class="flex flex-col gap-2"
      *ngIf="heading || subheading"
    >
      <div class="flex flex-row justify-between">
        <div>
          <div
            class="font-accent font-bold text-4xl"
            *ngIf="heading"
          >
            {{ heading | translate }}
          </div>
          <div
            class="text-xl px-5 font-base"
            *ngIf="subheading"
          >
            {{ subheading }}
          </div>
        </div>
        <div class="flex flex-row">
          <app-kiosk-active-button-atom
            class="flex mr-5"
            [activeBackground]="backgroundColor?.value"
            [activeTextColor]="textColor?.value"
            [inactiveBackground]="textColor?.value"
            secondaryTextColor="#FFFFFF"
            label=""
            (clickEmitter)="scrollLeft()"
          >
            <i class="icon icon-arrow-left text-md"></i>
          </app-kiosk-active-button-atom>
          <app-kiosk-active-button-atom
            class="flex mr-5"
            [activeBackground]="backgroundColor?.value"
            [activeTextColor]="textColor?.value"
            [inactiveBackground]="textColor?.value"
            secondaryTextColor="#FFFFFF"
            label=""
            (clickEmitter)="scrollRight()"
          >
            <i class="icon icon-arrow-right text-md"></i>
          </app-kiosk-active-button-atom>
        </div>
      </div>
    </div>
  </div>
  <div
    class="flex flex-row overflow-x-auto scrollbar-hide scroll-smooth gap-3"
    #loyaltyCarousel
  >
    <ng-container *ngIf="displayRedeemableGifts">
      <div
        class="mr-3 max-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of redeemableAssets"
      >
        <app-kiosk-como-item-atom
          [asset]="asset"
          [displayAddButton]="true"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd(asset)"
          (assetRemove)="onAssetRemove(asset)"
        ></app-kiosk-como-item-atom>
      </div>
    </ng-container>
    <ng-container *ngIf="displayRedeemablePointShop">
      <div
        class="mr-3 max-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of redeemablePointShops"
      >
        <app-kiosk-como-item-atom
          [asset]="asset"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd(asset)"
          (assetRemove)="onAssetRemove(asset)"
        ></app-kiosk-como-item-atom>
      </div>
    </ng-container>
    <ng-container *ngIf="displayNotRedeemableGifts">
      <div
        class="mr-3 max-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of noRedeemableAssets"
      >
        <app-kiosk-como-item-atom
          [asset]="asset"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd(asset)"
          (assetRemove)="onAssetRemove(asset)"
        ></app-kiosk-como-item-atom>
      </div>
    </ng-container>
    <ng-container *ngIf="displayNotRedeemablePointShop">
      <div
        class="mr-3 max-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of noRedeemablePointShops"
      >
        <app-kiosk-como-item-atom
          [asset]="asset"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd(asset)"
          (assetRemove)="onAssetRemove(asset)"
        ></app-kiosk-como-item-atom>
      </div>
    </ng-container>
    <ng-container *ngIf="displayNotUsablePointShop">
      <div
        class="mr-3 max-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of pointShops"
      >
        <app-kiosk-como-item-atom
          [asset]="asset"
          (assetAdd)="onAssetAdd(asset)"
          (assetRemove)="onAssetRemove(asset)"
        ></app-kiosk-como-item-atom>
      </div>
    </ng-container>
  </div>
</div>
<!--<div-->
<!--  *ngIf="!comoUser"-->
<!--  class="m-5 border-4 border-solid rounded-lg"-->
<!--  [style.backgroundColor]="backgroundColor | contentBuilderColor"-->
<!--  [style.color]="textColor | contentBuilderColor"-->
<!--  [style.borderColor]="secondaryButtonBackgroundColor | contentBuilderColor"-->
<!--&gt;-->
<!--  <div class="mx-5 mt-5 text-4xl">-->
<!--    {{ connexionHeading }}-->
<!--  </div>-->
<!--  <app-kiosk-loyalty-connection-block-->
<!--    [textColor]="textColor"-->
<!--    [backgroundColor]="backgroundColor"-->
<!--    [cardsColor]="primaryButtonBackgroundColor"-->
<!--    [standalone]="true"-->
<!--    [firstCardLink]="linkConnexion"-->
<!--    [firstCardLabel]="connexionCardLabel"-->
<!--  ></app-kiosk-loyalty-connection-block>-->
<!--</div>-->
